import { createIcon } from '@chakra-ui/react';

export const HelpIcon = createIcon({
  displayName: 'HelpIcon',
  path: (
    <>
      <svg viewBox="0 0 44 43" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M22.0006 26.32C21.1806 26.32 20.5006 25.64 20.5006 24.82V21.48C20.5006 20.66 21.1806 19.98 22.0006 19.98C23.6206 19.98 24.9406 18.66 24.9406 17.0401C24.9406 15.4201 23.6206 14.1001 22.0006 14.1001C20.3806 14.1001 19.0606 15.4201 19.0606 17.0401C19.0606 17.86 18.3806 18.54 17.5605 18.54C16.7405 18.54 16.0605 17.86 16.0605 17.0401C16.0605 13.7601 18.7206 11.1001 22.0006 11.1001C25.2806 11.1001 27.9406 13.7601 27.9406 17.0401C27.9406 19.8 26.0406 22.12 23.5006 22.8V24.82C23.5006 25.64 22.8206 26.32 22.0006 26.32Z"
          fill="currentColor"
        />
        <path
          d="M22 43C10.14 43 0.5 33.36 0.5 21.5C0.5 9.64 10.14 0 22 0C33.86 0 43.5 9.64 43.5 21.5C43.5 33.36 33.86 43 22 43ZM22 3C11.8 3 3.5 11.3 3.5 21.5C3.5 31.7 11.8 40 22 40C32.2 40 40.5 31.7 40.5 21.5C40.5 11.3 32.2 3 22 3Z"
          fill="currentColor"
        />
        <path
          d="M22.0009 32C21.1809 32 20.3809 31.22 20.3809 30.38C20.3809 29.54 21.1609 28.76 22.0009 28.76C22.8409 28.76 23.6209 29.54 23.6209 30.38C23.6209 31.22 22.8409 32 22.0009 32Z"
          fill="currentColor"
        />
      </svg>
    </>
  ),
});
